"use client"

import {useEffect, useState} from "react";

export const useErrorValidations = (name) => {
    const [error, setError] = useState({
        isError: false,
        message: ''
    })
    // const dispatch = useDispatch()
    // const {validations} = useSelector(selectGlobalSelector)

    const reset = () =>{
        // dispatch({
        //     type: VALIDATION_REMOVE_BY_NAME,
        //     payload: {name}
        // })
    }
    //
    // useEffect(()=>{
    //     if (validations[name]){
    //         setError({
    //             isError: true,
    //             message: validations[name]
    //         })
    //     }else {
    //         if (error.isError){
    //             setError({
    //                 isError: false,
    //                 message: ''
    //             })
    //         }
    //     }
    // }, [validations[name]])

    return {
        error,
        reset,
    }
}